import React from "react";

const GrampanchayatInfo = () => {
  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      background: "#fffaf0",
      color: "#333",
      fontFamily: "'Noto Sans Devanagari', sans-serif",
      padding: "20px",
    },
    header: {
      textAlign: "center",
      padding: "30px 20px",
      background: "linear-gradient(90deg, #0603a88a, #f9d976)",
      color: "#000000ff",
      boxShadow: "0 4px 12px rgb(245 124 0 / 0.6)",
      fontWeight: "700",
      marginBottom: "20px",
    },
    style1: {
      fontSize: "2rem",
      marginBottom: "6px",
    },
    tagline: {
      fontSize: "1.25rem",
      fontWeight: "600",
      marginTop: "8px",
      textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
      letterSpacing: "1.5px",
    },
    mainContent: {
      flexGrow: 1,
      padding: "30px 40px",
      maxWidth: "900px",
      margin: "0 auto",
      background: "#ffffffcc",
      borderRadius: "15px",
      boxShadow: "0 6px 20px rgb(0 0 0 / 0.1)",
    },
    infoBox: {
      background: "#fff9e6",
      borderLeft: "6px solid #f57c00",
      padding: "20px 25px",
      marginBottom: "25px",
      borderRadius: "8px",
      boxShadow: "1px 1px 8px rgb(245 124 0 / 0.15)",
      transition: "box-shadow 0.3s ease",
    },
    infoBoxHover: {
      boxShadow: "3px 3px 20px rgb(245 124 0 / 0.3)",
    },
    infoBoxHeading: {
      color: "#000000ff",
      fontSize: "1.5rem",
      marginBottom: "15px",
      borderBottom: "2px solid #f57c00",
      paddingBottom: "6px",
      fontWeight: "700",
      letterSpacing: "1.1px",
    },
    paragraph: {
      fontSize: "1.1rem",
      lineHeight: 1.7,
      color: "#4a4a4a",
      marginBottom: "15px",
    },
    boldText: {
      color: "#b65e00",
      fontWeight: "700",
    },
    thanks: {
      textAlign: "center",
      fontSize: "1.3rem",
      fontWeight: "600",
      color: "#f57c00",
      marginTop: "40px",
      fontStyle: "italic",
    },
    footer: {
      textAlign: "center",
      backgroundColor: "#f57c00",
      color: "white",
      padding: "18px 10px",
      fontWeight: "600",
      letterSpacing: "1.2px",
      boxShadow: "0 -4px 15px rgb(245 124 0 / 0.8)",
      marginTop: "30px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <h1 style={styles.style1}>ग्राम पंचायत - वलनी पं. स. नागपूर</h1>
        <h2 style={{ ...styles.style1, ...styles.tagline }}>यशोगाथा</h2>
      </header>

      {/* Main content */}
      <main style={styles.mainContent}>
        <section style={styles.infoBox}>
          <h3 style={styles.infoBoxHeading}>ग्रामीण लोकसंख्या व माहिती</h3>
          <p style={styles.paragraph}>
            ग्रामपंचायत वलनीची लोकसंख्या २०१८ असुन कुटुंब संख्या २४८ आहे. वलनी गाव नागपूर ते कलमेश्वर तालुक्याद्वारे सीमांत असून नागपूर जिल्ह्यातील नाकापार्श्व भाग असून २० कि.मी. आहे.
            गावातील मुख्य व्यवसाय शेती आहे.
          </p>
          <p style={styles.paragraph}>
            ग्रामपंचायतीची स्थापना १९६९ ची असून गावाला राज्यस्तरीय व जिल्हास्तरीय पुरस्कार प्राप्त झाले आहे.
          </p>
        </section>

        <section style={styles.infoBox}>
          <h3 style={styles.infoBoxHeading}>ODF+ कामगिरी</h3>
          <p style={styles.paragraph}>
            ग्रामपंचायत वलनी येथे ODF+ कामगिरी सत्तवता सन २०१८-१९ मध्ये झाली. ODF+ कामगिरीचे मुख्य उद्दिष्ट गावात लोकांच्या कचर्‍याचा योग्य प्रकारे व्यवस्थापन करणे आहे.
          </p>
          <p style={styles.paragraph}>
            <b style={styles.boldText}>घनकचरा व्यवस्थापन</b>: ग्रामपंचायत वलनी मध्ये कचरा व्यवस्थापनासाठी योग्य व्यवस्था केली आहे, प्लास्टिक कचर्‍याला वेगळे टाकण्याची सोय आहे आणि इतर कचऱ्याचे व्यवस्थापन प्रभावीपणे केले जाते.
          </p>
          <p style={styles.paragraph}>
            <b style={styles.boldText}>सांडपाणी व्यवस्थापन</b>: गावातील सांडपाणी योग्य प्रकारे व्यवस्थापित केली जाते व परिसर स्वच्छ ठेवला जातो.
          </p>
        </section>

        <section style={styles.infoBox}>
          <h3 style={styles.infoBoxHeading}>प्लास्टिक कचरा व्यवस्थापन</h3>
          <p style={styles.paragraph}>
            प्लास्टिक कचऱ्याला वेगळे गोळा करुन पुनर्वापरासाठी व पर्यावरणासाठी सुरक्षित पद्धतीने नष्ट केले जाते.
          </p>
        </section>

        <section style={styles.infoBox}>
          <h3 style={styles.infoBoxHeading}>शौचालय व्यवस्थापन</h3>
          <p style={styles.paragraph}>
            ग्रामपंचायत वलनी मध्ये सार्वजनिक आणि वैयक्तिक शौचालयांची व्यवस्था असून ते स्वच्छतेचे पालन करतात.
          </p>
        </section>

        <section style={styles.infoBox}>
          <h3 style={styles.infoBoxHeading}>मेळा गाठ व्यवस्थापन</h3>
          <p style={styles.paragraph}>
            ग्रामपंचायत येथे मेळा गाठ स्वच्छ आणि सुव्यवस्थित ठेवण्यात येतो, ज्यामुळे लोकसामान्यांना सुविधा मिळते.
          </p>
        </section>

        <p style={styles.thanks}>धन्यवाद !</p>
      </main>

      {/* Footer */}
      <footer style={styles.footer}>
        © 2025 ग्रामपंचायत वलनी, पं. स. नागपूर, जि. नागपूर
      </footer>
    </div>
  );
};

export default GrampanchayatInfo;
